import React, {ErrorInfo} from 'react';

import {Description, ErrorArea, ErrorAreaRoot, ErrorName, ErrorStack, Root, Title} from './styled';

interface ErrorBoundaryState {
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
    state: ErrorBoundaryState = {error: null, errorInfo: null};

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const {error, errorInfo} = this.state;

        if (errorInfo === null || error === null) {
            return this.props.children;
        }

        return (
            <Root>
                <Title>Что-то пошло не так :(</Title>
                <Description>Обратитесь в службу поддержки с информацией об ошибке.</Description>

                <ErrorAreaRoot>
                    <ErrorArea>
                        <ErrorName>{error.toString()}</ErrorName>
                        <ErrorStack>{errorInfo.componentStack}</ErrorStack>
                    </ErrorArea>
                </ErrorAreaRoot>
            </Root>
        );
    }
}
